"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adaptMdObjectWidthItemsToPivotTable = exports.adaptReferencePointWidthItemsToPivotTable = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var sdk_ui_pivot_1 = require("@gooddata/sdk-ui-pivot");
var sdk_model_1 = require("@gooddata/sdk-model");
var bucketHelper_1 = require("../../../utils/bucketHelper");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var isMeasureWidthItemMatchedByFilter = function (widthItem, filter) {
    return filter.selectedElements.some(function (selectedElement) {
        return widthItem.measureColumnWidthItem.locators.some(function (locator) {
            return !sdk_model_1.isMeasureLocator(locator) && locator.attributeLocatorItem.element === selectedElement.uri;
        });
    });
};
var matchesMeasureColumnWidthItemFilters = function (widthItem, filters, columnAttributes) {
    return filters
        .filter(bucketHelper_1.isAttributeFilter)
        .filter(function (filter) {
        return columnAttributes.some(function (columnBucketItem) {
            return sdk_model_1.areObjRefsEqual(columnBucketItem.dfRef, filter.displayFormRef);
        });
    })
        .every(function (filter) {
        var shouldBeMatched = !filter.isInverted;
        return shouldBeMatched === isMeasureWidthItemMatchedByFilter(widthItem, filter);
    });
};
var matchesWidthItemFilters = function (widthItem, filters, columnAttributes) {
    if (sdk_ui_pivot_1.isMeasureColumnWidthItem(widthItem)) {
        return matchesMeasureColumnWidthItemFilters(widthItem, filters, columnAttributes);
    }
    return true;
};
var containsMeasureLocator = function (widthItem) {
    return widthItem.measureColumnWidthItem.locators.some(function (locator) { return sdk_model_1.isMeasureLocator(locator); });
};
var widthItemLocatorsHaveProperLength = function (widthItem, measuresCount, columnAttributesCount) {
    var widthItemLocatorsLength = widthItem.measureColumnWidthItem.locators.length;
    var hasWidthItemLocators = widthItemLocatorsLength > 0;
    var hasMeasureLocators = measuresCount > 0 && containsMeasureLocator(widthItem);
    var hasNotMeasureLocators = measuresCount === 0 && !containsMeasureLocator(widthItem);
    var widthItemLocatorsMatchesColumnAttributesLength = widthItemLocatorsLength === columnAttributesCount + 1;
    var widthItemLocatorsHasLengthAsColumnAttributesLength = widthItemLocatorsLength === columnAttributesCount;
    var locatorsMatchesLength = hasMeasureLocators && widthItemLocatorsMatchesColumnAttributesLength;
    var locatorsAreEmpty = hasNotMeasureLocators && widthItemLocatorsHasLengthAsColumnAttributesLength;
    return hasWidthItemLocators && (locatorsMatchesLength || locatorsAreEmpty);
};
function removeInvalidLocators(columnWidth, measureLocalIdentifiers, columnAttributeLocalIdentifiers) {
    return columnWidth.measureColumnWidthItem.locators.filter(function (locator) {
        // filter out invalid measure locators
        if (sdk_model_1.isMeasureLocator(locator)) {
            return includes_1.default(measureLocalIdentifiers, locator.measureLocatorItem.measureIdentifier);
        }
        // filter out invalid column attribute locators
        return includes_1.default(columnAttributeLocalIdentifiers, locator.attributeLocatorItem.attributeIdentifier);
    });
}
function transformToWeakMeasureColumnWidthItem(columnWidth) {
    if (sdk_ui_pivot_1.isAbsoluteColumnWidth(columnWidth.measureColumnWidthItem.width) &&
        columnWidth.measureColumnWidthItem.locators.length === 1 &&
        sdk_model_1.isMeasureLocator(columnWidth.measureColumnWidthItem.locators[0])) {
        return {
            measureColumnWidthItem: {
                width: columnWidth.measureColumnWidthItem.width,
                locator: columnWidth.measureColumnWidthItem.locators.filter(sdk_model_1.isMeasureLocator)[0],
            },
        };
    }
}
// removes attribute widthItems with invalid identifiers
// removes measure widthItems with invalid identifiers and invalid number of locators
function adaptWidthItemsToPivotTable(originalColumnWidths, measureLocalIdentifiers, rowAttributeLocalIdentifiers, columnAttributeLocalIdentifiers, filters, firstColumnAttributeAdded, columnAttributes, isAdaptPropertiesToInsight) {
    if (!originalColumnWidths) {
        return originalColumnWidths;
    }
    return originalColumnWidths.reduce(function (columnWidths, columnWidth) {
        if (sdk_ui_pivot_1.isMeasureColumnWidthItem(columnWidth)) {
            var filteredMeasureColumnWidthItem = {
                measureColumnWidthItem: tslib_1.__assign(tslib_1.__assign({}, columnWidth.measureColumnWidthItem), { locators: removeInvalidLocators(columnWidth, measureLocalIdentifiers, columnAttributeLocalIdentifiers) }),
            };
            // need to filter this too, so it takes in consideration previous row bucket identifiers that were moved to column bucket, as same as is done with referencePoint
            var filteredColumnAttributeLocalIdentifiers_1 = [];
            if (isAdaptPropertiesToInsight) {
                filteredColumnAttributeLocalIdentifiers_1 = [];
                filteredMeasureColumnWidthItem.measureColumnWidthItem.locators.forEach(function (locator) {
                    if (sdk_model_1.isAttributeLocator(locator)) {
                        columnAttributeLocalIdentifiers.forEach(function (columnAttributeIdentifier) {
                            if (columnAttributeIdentifier === locator.attributeLocatorItem.attributeIdentifier) {
                                filteredColumnAttributeLocalIdentifiers_1.push(columnAttributeIdentifier);
                            }
                        });
                    }
                });
            }
            else {
                filteredColumnAttributeLocalIdentifiers_1 = columnAttributeLocalIdentifiers;
            }
            if (firstColumnAttributeAdded) {
                var transformedWeakMeasureWidthItem = transformToWeakMeasureColumnWidthItem(columnWidth);
                if (transformedWeakMeasureWidthItem) {
                    columnWidths.push(transformedWeakMeasureWidthItem);
                    return columnWidths;
                }
            }
            if (matchesWidthItemFilters(filteredMeasureColumnWidthItem, filters, columnAttributes) &&
                widthItemLocatorsHaveProperLength(filteredMeasureColumnWidthItem, measureLocalIdentifiers.length, filteredColumnAttributeLocalIdentifiers_1.length)) {
                columnWidths.push(filteredMeasureColumnWidthItem);
                return columnWidths;
            }
        }
        else if (sdk_ui_pivot_1.isAttributeColumnWidthItem(columnWidth)) {
            if (includes_1.default(rowAttributeLocalIdentifiers, columnWidth.attributeColumnWidthItem.attributeIdentifier)) {
                columnWidths.push(columnWidth);
                return columnWidths;
            }
        }
        else if ((sdk_ui_pivot_1.isAllMeasureColumnWidthItem(columnWidth) || sdk_ui_pivot_1.isWeakMeasureColumnWidthItem(columnWidth)) &&
            measureLocalIdentifiers.length > 0) {
            columnWidths.push(columnWidth);
            return columnWidths;
        }
        return columnWidths;
    }, []);
}
function adaptReferencePointWidthItemsToPivotTable(originalColumnWidths, measures, rowAttributes, columnAttributes, previousRowAttributes, previousColumnAttributes, filters) {
    var measureLocalIdentifiers = measures.map(function (measure) { return measure.localIdentifier; });
    var rowAttributeLocalIdentifiers = rowAttributes.map(function (rowAttribute) { return rowAttribute.localIdentifier; });
    var columnAttributeLocalIdentifiers = columnAttributes.map(function (columnAttribute) { return columnAttribute.localIdentifier; });
    var previousRowAttributeLocalIdentifiers = previousRowAttributes.map(function (rowAttribute) { return rowAttribute.localIdentifier; });
    var previousColumnAttributeLocalIdentifiers = previousColumnAttributes.map(function (columnAttribute) { return columnAttribute.localIdentifier; });
    var filteredRowAttributeLocalIdentifiers = rowAttributeLocalIdentifiers.filter(function (rowAttributeLocalIdentifier) {
        return !previousColumnAttributeLocalIdentifiers.includes(rowAttributeLocalIdentifier);
    });
    var filteredColumnAttributeLocalIdentifiers = columnAttributeLocalIdentifiers.filter(function (columnAttributeLocalIdentifier) {
        return !previousRowAttributeLocalIdentifiers.includes(columnAttributeLocalIdentifier);
    });
    var firstColumnAttributeAdded = previousColumnAttributes.length === 0 && columnAttributes.length === 1;
    return adaptWidthItemsToPivotTable(originalColumnWidths, measureLocalIdentifiers, filteredRowAttributeLocalIdentifiers, filteredColumnAttributeLocalIdentifiers, filters, firstColumnAttributeAdded, columnAttributes);
}
exports.adaptReferencePointWidthItemsToPivotTable = adaptReferencePointWidthItemsToPivotTable;
function adaptMdObjectWidthItemsToPivotTable(originalColumnWidths, insight) {
    var rowBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.ATTRIBUTE);
    var columnBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.COLUMNS);
    var measureLocalIdentifiers = sdk_model_1.insightMeasures(insight).map(sdk_model_1.measureLocalId);
    var rowAttributeLocalIdentifiers = rowBucket ? sdk_model_1.bucketAttributes(rowBucket).map(sdk_model_1.attributeLocalId) : [];
    var columnAttributeLocalIdentifiers = columnBucket
        ? sdk_model_1.bucketAttributes(columnBucket).map(sdk_model_1.attributeLocalId)
        : [];
    return adaptWidthItemsToPivotTable(originalColumnWidths, measureLocalIdentifiers, rowAttributeLocalIdentifiers, columnAttributeLocalIdentifiers, [], false, [], true);
}
exports.adaptMdObjectWidthItemsToPivotTable = adaptMdObjectWidthItemsToPivotTable;
//# sourceMappingURL=widthItemsHelpers.js.map